<template>
  <div class="contacts-tracking-birthday">
    <div class="contacts-tracking-birthday__count"
         :class="{'contacts-tracking-birthday__count_opacity': checkedList.length}"
    >
      {{checkedList.length}} selected
    </div>
    <ContactsTrackingTable :rows="rows"
                           :columns="columns"
                           :noData="noData"
                           :page="page"
                           :scroll="scroll"
                           :checkedList="checkedList"
                           :checkboxValue="checkboxValue"
                           :allChecked="allChecked"
                           :listCheckbox="listCheckbox"
                           :choseChecked="choseChecked"
                           @getAll="checkedAll"
                           @clickItem="choseOperation"
                           @changeChecked="changeChecked"
                           @update="updateComment"
                           @filter="setFilter"
                           @updateToggle="updateStatusCall"
    />
    <Pagination :data="fullInfo" :getQuery="getBirthdays" :limit="page.defLimit" :sticky="true" class="bb-pagination"/>
  </div>
</template>

<script>
import ContactsTrackingTable
  from '@/components/Dissemination/Sales/CRM/ContactsTrackingLists/ContactsTrackingTable/ContactsTrackingTable'
import {trackingBirthdaysTableColumns} from '@/constants/TablesOptions/contactsTrackingList/trackingBirthdaysTable'
import ContactsApi from '@/api/Contacts/api'
import {cloneDeep, filter, find, findIndex, get} from 'lodash'
import moment from 'moment'
import Pagination from '@/components/Main/Pagination/Pagination'
import callStatusesBirthDays from '@/constants/callStatusesBirthDays'

export default {
  name: 'ContactsTrackingBirthdays',
  props: ['filterByDate', 'scroll', 'valueSearch'],
  components: {
    ContactsTrackingTable,
    Pagination
  },
  data () {
    return {
      rows: [],
      columns: trackingBirthdaysTableColumns,
      fullInfo: {},
      page: {
        defLimit: 50,
        currentPage: 1
      },
      noData: false,
      checkedList: [],
      totalDocs: 0,
      listCheckbox: ['All', 'Deselect all'],
      callStatusList: [],
      filterByCallStatus: '',
      filterByBirthDay: '',
      infoForCongratulate: {
        name: 'isCongratulate',
        textAttentionForSetTrue: 'Are you sure you called the customer?',
        textAttentionForSetFalse: 'Are you sure you not called the customer?',
      }
    }
  },
  computed: {
    emailStore: {
      get () {
        return this.$store.getters.emailStore
      },
      set (data) {
        this.$store.dispatch('setEmailStore', data)
      }
    },
    allChecked () {
      return this.checkedList.length === this.totalDocs
    },
    choseChecked () {
      return this.checkedList.length > 0 && this.checkedList.length < this.totalDocs
    },
    checkboxValue () {
      return this.checkedList.length
    }
  },
  methods: {
    setFilter (data, item, column) {
      switch (column.filterId ) {
        case 'birthday': {
          this.setFilterByBirthDay(data);
          break;
        }
        default: this.setFilterByCallStatus(data, item);
      }
      this.getBirthdays({});
    },
    setFilterByBirthDay (date) {
      this.filterByBirthDay = date ?`${date};;1` : '';
    },
    setFilterByCallStatus (data, item) {
      const status = find(this.callStatusList, {id: item.id});

      if (status) {
        status.checked = data;
        const checked = this.callStatusList.filter(item => item.checked);
        const ids = checked.map((item) => item.id);
        this.filterByCallStatus = ids.length === 1 ? ids.join('&isCongratulate=') : null;
      }
    },
    updateStatusCall({value, row }) {
      const result = cloneDeep(row);
      result.isCongratulate.value = value;
      const index = findIndex(this.rows, {id: row.id});
      this.rows.splice(index, 1, result);

      ContactsApi.editContactByField(result.id, {...result, isCongratulate: value})
        .then((resp) => {
          if (index !== -1) {
            this.rows.splice(index, 1, {
              ...resp.data,
              isCongratulate: {
                ...this.infoForCongratulate,
                value: resp.data.isCongratulate,
                id: resp.data.id,
              }
            })
          }
        })
        .catch((err) => {
          console.error(err)
        })
    },
    updateComment ({row, comment}) {
      const result = cloneDeep(row);
      result.comment = comment;
      const index = findIndex(this.rows, {id: row.id});
      this.rows.splice(index, 1, result);
      ContactsApi.editContactByField(result.id, {
        ...result,
        isCongratulate: result.isCongratulate.value
      })
        .then((resp) => {
          if (index !== -1) {
            this.rows.splice(index, 1, {
              ...resp.data,
              isCongratulate: {
                value: resp.data.isCongratulate,
                ...this.infoForCongratulate,
                id: resp.data.id,
              },
            })
          }
        })
        .catch((err) => {
          console.error(err)
        })
    },
    checkedAll () {
      if (this.allChecked) {
        this.checkedList = []
        return
      }
      this.getBirthdays({limit: 99999, check: true})
    },
    choseOperation (operation) {
      if (operation === 'All') {
        this.$emit('loader', true)
        ContactsApi.getBirthdays({
          page: 1,
          limit: 999,
          birthday: '01-01;;12-31;;1'
        })
          .then((resp) => {
            this.checkedList = resp.data.clientbirthdays
            this.$emit('loader', false)
          })
          .catch((e) => {
            this.$emit('loader', false)
            console.error(e)
          })
      }
      if (operation === 'Deselect all') {
        this.checkedList = []
      }
    },
    changeChecked ({rowId, row}) {
      const index = findIndex(this.checkedList, {id: rowId})
      if (index !== -1) {
        this.checkedList.splice(index, 1)
      } else {
        this.checkedList.push(row)
      }
    },
    getBirthdays ({limit = this.page.defLimit, page, check}) {
      if (!this.filterByDate) return
      this.page.currentPage = page || this.page.currentPage
      const filterByDate = this.formatDateFilter()
      this.$emit('loader', true)
      const body = {
        limit,
        page,
        birthday: this.filterByBirthDay || filterByDate,
        callStatus: this.filterByCallStatus,
        search: this.valueSearch
      }
      ContactsApi.getBirthdays(body)
        .then((resp) => {
          if (check) {
            this.checkedList = resp.data.clientbirthdays
            this.$emit('loader', false)
            return
          }
          this.fullInfo = resp.data
          this.totalDocs = resp.data.totalDocs
          this.noData = resp.data.clientbirthdays.length === 0
          this.rows = resp.data.clientbirthdays.map(item => ({
            ...item,
            isCongratulate: {
              value: item.isCongratulate || false,
              ...this.infoForCongratulate,
              id: item.id,
            }
          }));
          this.$emit('loader', false)
        })
        .catch((err) => {
          this.$emit('loader', false)
          console.error(err)
        })
    },
    formatDateFilter () {
      const dates = this.filterByDate.split(';;')
      const monthFirst = +moment(new Date(dates[0])).format('MM')
      const monthSecond = +moment(new Date(dates[1])).format('MM')
      const startFirstDate = moment(new Date(dates[0])).format('MM-DD')
      const fullFirstDate = `${startFirstDate};;12-31`
      const endSecondDate = moment(new Date(dates[1])).subtract(1, 'days').format('MM-DD')
      const fullSecondDate = `01-01;;${endSecondDate}`
      const allTime = startFirstDate !== endSecondDate
      if (allTime || monthSecond < monthFirst) return `${fullFirstDate};;1&birthday[]=${fullSecondDate};;1`
      return `${startFirstDate};;${endSecondDate};;1`
    }
  },
  watch: {
    filterByDate () {
      this.getBirthdays({})
    },
    checkedList (newVal) {
      this.emailStore = newVal
    },
    valueSearch () {
      this.getBirthdays({})
    }
  },
  beforeMount () {
    this.getBirthdays({});
    this.callStatusList = cloneDeep(callStatusesBirthDays);
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../../../sass/variables";
  @import "../../../../../../sass/mixins";
  .contacts-tracking-birthday {
    &__count {
      display: flex;
      justify-content: flex-end;
      padding-top: 4px;
      font-size: 12px;
      line-height: 14px;
      color: $color-silver;
      opacity: 0;

      &_opacity {
        opacity: 1;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Dissemination/Sales/CRM/ContactsTrackingLists/ContactsTrackingCategories/ContactsTrackingBirthdays.vue